import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import { useState } from "react";
import FeedbackPopup from "./feedbackPopup";
import { postData } from "../helper/api";
import dayjs from "dayjs";

export default function MessageActions({ responseData, worksheetId }) {
  const [like, setLike] = useState<boolean | null>(null);
  const [copied, setCopied] = useState(false);
  const [openFeedbackConfirmation, setOpenFeedbackConfirmation] =
    useState<boolean>(false);

  const handleCopy = () => {
    console.log(responseData);
    navigator.clipboard.writeText(responseData.message);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000); // reset after 3s
  };

  const handleFeedback = async (comments: string, isLike = false) => {
    setOpenFeedbackConfirmation(false);

    var requestModel = {
      comments: comments,
      worksheetId: worksheetId,
      isThumbsUp: isLike,
      responseId: responseData.id,
    };
    await postData(requestModel, `chat/feedback`);

    setLike(isLike);
  };

  const handleThumbsUp = async () => {
    setLike(true);
    await handleFeedback(null, true);
  };

  const handleThumbsDown = async () => {
    setOpenFeedbackConfirmation(true);
  };

  return (
    <>
      {responseData?.id && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            gap: 1,
            px: 4,
          }}
        >
          {responseData.role !== "user" && (
            <>
              <Tooltip title="Copy">
                <IconButton size="small" onClick={handleCopy}>
                  {copied ? (
                    <CheckIcon fontSize="small" color="success" />
                  ) : (
                    <ContentCopyIcon fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>
              <Tooltip title="Like">
                <IconButton
                  size="small"
                  color={like === true ? "primary" : "default"}
                  onClick={() => handleThumbsUp()}
                >
                  <ThumbUpAltOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Dislike">
                <IconButton
                  size="small"
                  color={like === false ? "error" : "default"}
                  onClick={() => handleThumbsDown()}
                >
                  <ThumbDownAltOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              {responseData.createdDateTime && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    marginTop: "6px",
                  }}
                >
                  {dayjs(responseData.createdDateTime).format(
                    "MMM D, YYYY h:mm A"
                  )}
                </Typography>
              )}
            </>
          )}

          <FeedbackPopup
            open={openFeedbackConfirmation}
            onClose={() => setOpenFeedbackConfirmation(false)}
            onSubmit={handleFeedback}
          />
        </Box>
      )}
    </>
  );
}
